export default __webpack_public_path__ + "static/media/feature--review.de4e3c47.png";